var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showPreloader)?_c('div',{staticClass:"mobile-menu",class:{'activeMobile': _vm.active},on:{"click":function($event){return _vm.open()}}},[_c('div',{staticClass:"lines"}),_c('div',{staticClass:"lines"}),_c('div',{staticClass:"lines"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }